import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type SignatureProperties = {
  dataURL: string;
  width: number;
  height: number;
};

export type SignatureActionType = SignatureProperties;

export type SignatureConsentState = {
  signatureConsent: SignatureProperties;
  acceptTermsConsent: boolean;
};

export const initialSignatureConsentState: SignatureConsentState = {
  signatureConsent: { dataURL: '', width: 0, height: 0 },
  acceptTermsConsent: false,
};

const signatureConsentSlice = createSlice({
  name: 'signatureConsent',
  initialState: initialSignatureConsentState, // Usamos la constante directamente aquí
  reducers: {
    // Reducer para establecer el estado de `acceptTermsConsent`
    setAcceptTermsConsent(state, action: PayloadAction<{ value: boolean }>) {
      state.acceptTermsConsent = action.payload.value;
    },
    // Reducer para establecer la firma de consentimiento (`signatureConsent`)
    setSignatureConsent(state, action: PayloadAction<SignatureActionType>) {
      state.signatureConsent.dataURL = action.payload.dataURL;
      state.signatureConsent.width = action.payload.width;
      state.signatureConsent.height = action.payload.height;
    },
    // Opcional: Reducer explicito para resetear el estado dentro del slice,
    // Mas claro que usar solo extraReducers con acciones globales.
    resetSignatureConsentState() {
      return initialSignatureConsentState; // Retornar el estado inicial directamente
    },
  },
  extraReducers: (builder) => {
    // Al resetear su estado inicial completo.
    builder.addCase('RESET_SIGNATURECONSENT_STATE', () => initialSignatureConsentState);
  },
});

export const { setAcceptTermsConsent, setSignatureConsent, resetSignatureConsentState } =
  signatureConsentSlice.actions;

export default signatureConsentSlice.reducer;
